import {z} from 'zod';

import i18n from '@dms/i18n';

const optionIdsSchema = z.array(z.string().trim().nullable());

export const LabourRateFormSchema = z.object({
  name: z.string().trim().min(1, i18n.t('general.validations.fieldIsRequired')),
  authorizationProfileIds: optionIdsSchema.min(1, i18n.t('general.validations.fieldIsRequired')),
  workTypeIds: optionIdsSchema.nullable().optional(),
  rateTypes: optionIdsSchema.min(1, i18n.t('general.validations.fieldIsRequired')),
  rateUnitPriceWithoutVat: z.number(),
  vehicleGroupIds: optionIdsSchema.nullable().optional(),
  vehicleClassIds: optionIdsSchema.nullable().optional(),
  vehicleFuelTypes: optionIdsSchema.nullable().optional(),
});

export type LabourRateFormValues = z.infer<typeof LabourRateFormSchema>;
